// src/api/auth.ts

import axios, { AxiosInstance, AxiosResponse } from "axios";
import { AuthResponse, LoginCredentials, RegisterData } from "../types/auth";
import { handleUnauthorizedError } from "../utils/authSession";

const apiClient: AxiosInstance = axios.create({
  baseURL: "https://ser.100gan.ir",
  headers: {
    "Content-Type": "application/json",
    Accept: "*/*",
  },
});

// اینترسپتر برای اضافه کردن خودکار access_token به هدر درخواست‌ها
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token"); // کلید را به access_token تغییر می‌دهیم
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  handleUnauthorizedError
);

export const authApi = {
  login: async (credentials: LoginCredentials): Promise<AuthResponse> => {
    const response: AxiosResponse<AuthResponse> = await apiClient.post(
      "/auth/login",
      credentials
    );
    return response.data;
  },

  register: async (data: RegisterData): Promise<AuthResponse> => {
    const response: AxiosResponse<AuthResponse> = await apiClient.post(
      "/auth/register",
      data
    );
    return response.data;
  },

  // می‌توانید تابعی برای رفرش کردن توکن نیز اضافه کنید
  refreshToken: async (
    refresh_token: string
  ): Promise<{ access_token: string }> => {
    const response = await apiClient.post("/auth/refresh", { refresh_token });
    return response.data;
  },

  logout: async (): Promise<void> => {
    await apiClient.post("/auth/logout");
  },
};
